'use client'
import type { GetCategoryTreeResponse } from 'cf-grpc/creativefabrica/content/v2/service_pb'

import { MenuProvider } from './context'
import { MenuHead } from './head'
import { Dropdown } from './dropdown'

interface MenuProps {
  title: string
  showAll: string
  menuItems: GetCategoryTreeResponse
  categoryPath: string
  linkPrefix?: string
}

export function MenuComp({ menuItems, title, showAll, categoryPath, linkPrefix }: MenuProps) {
  return (
    <MenuProvider>
      <div data-testid="category-menu">
        <MenuHead title={title} showAll={showAll} />
        <Dropdown
          menuItems={menuItems}
          showAll={showAll}
          categoryPath={categoryPath}
          linkPrefix={linkPrefix}
        />
      </div>
    </MenuProvider>
  )
}
